import {
  AiCritical,
  AiWarn,
  AiTransferred,
  AiScheduleCanceled,
  AiScheduleRescheduled,
  AiScheduleConfirmed,
  AiScheduledAdded,
} from '@frontend/styled-icons';
import {
  AiSuccessWithTooltip,
  AiWarnWithTooltip,
  AiCriticalWithTooltip,
  AiSuccess,
  AiTransferredWithTooltip,
  AiQuestion,
  AiQuestionWithTooltip,
} from './ai';

export const OUTCOME_MAPPING = {
  SUCCESS: 'success',
  ROUTE_ANSWERED: 'route_answered',
  ROUTE_MISSED: 'route_missed',
  FATAL: 'fatal',
  TEXT_HANDOFF: 'text_handoff',
  INCOMPLETE: 'incomplete',
} as const;

export const AI_EVENT_BADGE_TYPE = {
  ERROR: 'error',
  NOT_APPLICABLE: 'not-applicable',
  SCHEDULE_ADDED: 'added-to-schedule',
  SCHEDULE_CANCELLED: 'cancelled',
  SCHEDULE_CONFIRMED: 'confirmed',
  SCHEDULE_RESCHEDULED: 'rescheduled',
  TRANSFER_MISSED: 'transfer-missed',
  TRANSFERRED_TO_STAFF: 'transferred-to-staff',
} as const;

export const getAiEventIcon = ({
  event,
}: {
  event: (typeof AI_EVENT_BADGE_TYPE)[keyof typeof AI_EVENT_BADGE_TYPE];
}) => {
  switch (event) {
    case AI_EVENT_BADGE_TYPE.TRANSFER_MISSED:
      return <AiWarn />;
    case AI_EVENT_BADGE_TYPE.SCHEDULE_CANCELLED:
      return <AiScheduleCanceled />;
    case AI_EVENT_BADGE_TYPE.SCHEDULE_ADDED:
      return <AiScheduledAdded />;
    case AI_EVENT_BADGE_TYPE.SCHEDULE_RESCHEDULED:
      return <AiScheduleRescheduled />;
    case AI_EVENT_BADGE_TYPE.SCHEDULE_CONFIRMED:
      return <AiScheduleConfirmed />;
    case AI_EVENT_BADGE_TYPE.ERROR:
      return <AiCritical />;
    case AI_EVENT_BADGE_TYPE.TRANSFERRED_TO_STAFF:
      return <AiTransferred />;
    default:
      return null;
  }
};

export type OutcomeType = (typeof OUTCOME_MAPPING)[keyof typeof OUTCOME_MAPPING];

export const getAiOutcomeIcon = ({ outcome }: { outcome: OutcomeType }) => {
  switch (outcome) {
    case OUTCOME_MAPPING.SUCCESS:
      return <AiSuccess />;
    case OUTCOME_MAPPING.ROUTE_ANSWERED:
      return <AiTransferred />;
    case OUTCOME_MAPPING.ROUTE_MISSED:
      return <AiWarn />;
    case OUTCOME_MAPPING.FATAL:
      return <AiCritical />;
    case OUTCOME_MAPPING.TEXT_HANDOFF:
      return <AiTransferred />;
    case OUTCOME_MAPPING.INCOMPLETE:
      return <AiQuestion />;
    default:
      return null;
  }
};

export const getAiOutcomeIconWithTooltip = ({ outcome, tooltip }: { outcome: OutcomeType; tooltip?: string }) => {
  switch (outcome) {
    case OUTCOME_MAPPING.SUCCESS:
      return <AiSuccessWithTooltip tooltipText={tooltip} />;
    case OUTCOME_MAPPING.ROUTE_ANSWERED:
      return <AiTransferredWithTooltip tooltipText={tooltip} />;
    case OUTCOME_MAPPING.ROUTE_MISSED:
      return <AiWarnWithTooltip tooltipText={tooltip} />;
    case OUTCOME_MAPPING.FATAL:
      return <AiCriticalWithTooltip tooltipText={tooltip} />;
    case OUTCOME_MAPPING.TEXT_HANDOFF:
      return <AiTransferredWithTooltip tooltipText={tooltip} />;
    case OUTCOME_MAPPING.INCOMPLETE:
      return <AiQuestionWithTooltip tooltipText={tooltip} />;
    default:
      return null;
  }
};
